import { useTranslation } from "react-i18next";
import { Button, Icon, Input, Modal } from "semantic-ui-react";

import "modules/AppointmentDetails/components/CarMileageModal/CarMileageModal.scss";

interface CarMileageModalPropTypes {
  showCarMileageModal: boolean;
  onSetCurrentMileage: (val: number) => void;
  onResetCarMileageModal: () => void;
  currentMileage: number | null;
  onHandleCarMileageConfirm: () => void;
  title: string;
  isLoading?: boolean;
}

export const CarMileageModal = ({
  showCarMileageModal,
  onSetCurrentMileage,
  onResetCarMileageModal,
  currentMileage,
  onHandleCarMileageConfirm,
  title,
  isLoading
}: CarMileageModalPropTypes) => {
  const { t } = useTranslation();
  return (
    <Modal className="CarMileageModal" size="tiny" centered open={!!showCarMileageModal}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <p className="CarMileageModal__title">
          {t("v8_mileage", "Mileage")} <span className="CarMileageModal__asterisk">*</span>
        </p>
        <Input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          defaultValue={currentMileage}
          onBeforeInput={(e: React.FormEvent<HTMLInputElement> & { data: string }) => {
            if (!/^\d+$/.test(e.data)) {
              e.preventDefault();
            }
          }}
          onChange={e => {
            onSetCurrentMileage(Number(e.target.value));
          }}
          className="car-mileage-input"
        />
      </Modal.Content>
      <Modal.Actions className="car-mileage-action-container">
        <Button onClick={onResetCarMileageModal}>
          {t("v8_cancel", "Cancel")}
          <Icon className="xmark" />
        </Button>
        <Button color="green" disabled={!currentMileage || currentMileage <= 0 || isLoading} loading={isLoading} onClick={onHandleCarMileageConfirm}>
          {t("v8_save", "Save")}
          <Icon className="check" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
